import { createUniqueId } from '@/utils/createId'
import Confirmation from './Confirmation'

export default {
  namespaced: true,
  state: () => ({
    confirmations: [],
  }),
  mutations: {
    addConfirmation(state, confirmation) {
      state.confirmations.push(confirmation)
    },
    removeConfirmation(state, { id }) {
      const index = state.confirmations.findIndex(({ id: cid }) => cid === id)
      if (index >= 0) {
        state.confirmations.splice(index, 1)
      }
    },
  },
  actions: {
    /**
     * Create a confirmation to be displayed
     * @param {Object} store - Vuex store that is auto-injected when this action is invoked
     * @param {Object} config - Action config
     * @param {String} [config.title] - Title of confirmation modal. Defaults to 'Confirm?'
     * @param {String} config.text - Body of confirmation modal
     * @param {Array<Object>} [config.options] - Configuration for options to present to the user
     *   Defaults to [{value: false}, {value: true}]
     * @param {any} config.options[].value - Value resolved by the confirmation promise when this button is pressed
     *   true and false have special connotations as accept/cancel
     * @param {String} config.options[].text - Text shown as button content
     *   Defaults based on value: true -> 'Confirm', false -> 'Cancel', any -> 'Continue'
     * @param {any} config.options[].buttonType - Button type passed to Button component
     *   Defaults based on value: true -> 'primary', false -> 'primary-outline', any -> null
     */
    create({ state, commit, dispatch }, { title, text, options }) {
      const id = createUniqueId(state.confirmations.map(({ id }) => id))

      const confirmation = new Confirmation({
        title,
        text,
        options,
        id,
      })

      confirmation.finally((success) => {
        dispatch('remove', { id })
        return success
      })

      commit('addConfirmation', confirmation)
      return confirmation
    },
    /**
     * Remove a confirmation
     * @param {Object} store - Vuex store that is auto-injected when this action is invoked
     * @param {Object} confirmation - Object containing confirmation ID to be removed
     *   Assumed to be the confirmation itself but this need not be the case
     * @param {any} confirmation.id - ID of the confirmation to be removed
     */
    remove({ state, commit }, { id }) {
      const confirmation = state.confirmations.find(({ id: cid }) => cid === id)
      if (confirmation) {
        commit('removeConfirmation', confirmation)
      }
    },
  },
}
